// extracted by mini-css-extract-plugin
export default {"root":"ResultModal_root__8qwPF","success":"ResultModal_success__mo6MY","error":"ResultModal_error__avQsS"};